import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const FilterDropdown = ({ value, onChange, options, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (optionValue) => {
        // Simulate event object to match current select behavior if needed, 
        // but simpler to just pass value. The parent expects event usually for selects,
        // so we'll adapt:
        const event = { target: { value: optionValue } };
        onChange(event);
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value) || options[0];

    return (
        <div className={`relative ${className}`} ref={dropdownRef}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-4 py-3 bg-[#F9F9F7] border border-[#C5A57D] rounded-xl flex justify-between items-center text-[#0A5F38] font-bold focus:outline-none focus:ring-1 focus:ring-[#0A5F38] hover:border-[#0A5F38] transition-colors shadow-[inset_0_1px_2px_rgba(0,0,0,0.05)]"
            >
                <span className="truncate">{selectedOption.label}</span>
                <ChevronDown
                    className={`w-5 h-5 text-[#0A5F38] transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="absolute z-50 w-full mt-2 bg-white border border-[#C5A57D] rounded-xl shadow-lg overflow-hidden animate-in fade-in zoom-in-95 duration-100">
                    <ul className="max-h-60 overflow-auto py-1">
                        {options.map((option) => (
                            <li key={option.value}>
                                <button
                                    type="button"
                                    onClick={() => handleSelect(option.value)}
                                    className={`w-full text-left px-4 py-3 transition-colors duration-150
                    ${value === option.value ? 'bg-[#E8F5E9] text-[#0A5F38] font-bold' : 'text-slate-700 hover:bg-[#0A5F38] hover:text-white'}
                  `}
                                >
                                    {option.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FilterDropdown;
